// extracted by mini-css-extract-plugin
export default {"container":"board_container__hbA8-","header":"board_header__mcJbd","cardsContainer":"board_cardsContainer__BUewo"};